import { ReactElement } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import CrashFallback from './CrashFallback';
import moment from 'moment/moment';
import { DateFormat } from 'utils/constants';
import store from 'features';
import { sendApplicationLog } from 'features/app/appThunks';
import { useLocation } from 'react-router';
import { useAppDispatch } from 'hooks/useAppStore';

type CrashFallbackProviderProps = {
  children: ReactElement;
  onReset?: () => void;
};

const CrashFallbackProvider = ({
  children,
  onReset
}: CrashFallbackProviderProps): ReactElement => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const sendErrorLog = (error: Error) => {
    const userAgent: string = navigator.userAgent;
    const errorMessage = `${error.name}: ${error.message}`;
    const errorStack: string = JSON.stringify(error.stack);
    const errorLocation: string = JSON.stringify(location);
    const errorTime: string = moment().format(DateFormat.LOG_DATETIME_FORMAT);
    const errorRedux: string = JSON.stringify(store.getState());

    const errorLog = {
      userAgent,
      errorMessage,
      errorStack,
      errorLocation,
      errorTime,
      errorRedux
    };

    dispatch(sendApplicationLog(errorLog));
  };

  return (
    <ErrorBoundary
      FallbackComponent={CrashFallback}
      onError={sendErrorLog}
      onReset={onReset}
    >
      {children}
    </ErrorBoundary>
  );
};

export default CrashFallbackProvider;
